import { ApiProperty } from '@nestjs/swagger';
import { ActivityBaseResponseDto } from './activity-base.response';

export class ActivityLessonLinkResponseDto {
  @ApiProperty({ type: 'string' })
  activityId!: string;

  @ApiProperty({ type: 'string' })
  lessonId!: string;

  @ApiProperty({ type: 'string', format: 'date-time' })
  createdAt!: string | Date;

  @ApiProperty({ type: 'string' })
  addedByUserId!: string;

  @ApiProperty({ type: Number })
  orderInLesson!: number;

  @ApiProperty({ type: () => ActivityBaseResponseDto })
  activity!: ActivityBaseResponseDto;
}
